import axios, { AxiosError } from "axios";
import { useContext } from "react";
import useSWR from "swr";
import { AuthContext } from "../../../context/AuthContext";
import { WithdrawalsEndpointEnum } from "../../../enums/endpoints";
import { WITHDRAWALS_API_URL } from "../../../utils/env";

export interface ITodayWithdrawal {
  Account: string;
  Amount: string;
  Decimals: number;
  Collateral: string;
  CollateralName: string;
  CounterParty: string;
  Fee: string;
  Status: string;
  TxType: string;
  L1TxHash: string;
  L2TxHash: string;
  BlockNumber: number;
  ChainID: number;
  Label: string;
  InitiatedTimestamp: number;
  FinalizedTimestamp: number;
  amount_human: number;
  initiated_at: string;
  finalized_at: string;
}

export interface ITodayWithdrawalsData {
  window: string;
  override_hours: number | null;
  window_start_unix_nanos: number;
  window_start_iso: string;
  count: number;
  withdrawals: ITodayWithdrawal[];
}

interface ITodayWithdrawalsEnvelope {
  success: boolean;
  message: string;
  data: ITodayWithdrawalsData;
}

// GET /api/withdrawals/today on the exchange-admin-api.
// The window is env-anchored to the daily kill-switch boundary
// (mainnet 08:00 UTC, testnet 04:15 UTC); see exchange-admin-api/api/
// withdrawals/today.ts for the shared logic. Polled every 30s so the
// section refreshes between admin actions without manual reload.
export const useTodayWithdrawals = () => {
  const { queryConfig, tokenId } = useContext(AuthContext);
  const endpoint = WITHDRAWALS_API_URL(WithdrawalsEndpointEnum.TODAY);

  return useSWR<ITodayWithdrawalsData, AxiosError>(
    tokenId ? [endpoint, tokenId] : undefined,
    async () => {
      const response = await axios.get<ITodayWithdrawalsEnvelope>(
        endpoint,
        queryConfig()
      );
      return response.data.data;
    },
    { refreshInterval: 30000 }
  );
};
